var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('router-view'),_c('div',{staticClass:"grey lighten-3"},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }